/**
 * Tiny, non-intrusive build-version badge.
 *
 * Renders a small monospace pill fixed to the bottom-right corner so anyone
 * can confirm at a glance which bundle the browser actually loaded. Hidden
 * from screen readers, click-through toggles a brief verbose tooltip with
 * the full build timestamp.
 */
import { useState } from "react";
import { BUILD_VERSION, BUILD_TIME } from "@/lib/buildInfo";

export function BuildBadge() {
  const [open, setOpen] = useState(false);
  return (
    <button
      type="button"
      aria-hidden="true"
      tabIndex={-1}
      onClick={() => setOpen((v) => !v)}
      title={`Build ${BUILD_VERSION} • ${BUILD_TIME}`}
      style={{
        position: "fixed",
        right: 8,
        bottom: 8,
        zIndex: 9999,
        fontFamily:
          "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
        fontSize: 10,
        lineHeight: 1,
        padding: "4px 8px",
        borderRadius: 999,
        background: "rgba(15,23,42,0.55)",
        color: "rgba(255,255,255,0.85)",
        border: "1px solid rgba(255,255,255,0.1)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        cursor: "pointer",
        userSelect: "none",
        pointerEvents: "auto",
      }}
    >
      {open ? `v${BUILD_VERSION} · ${BUILD_TIME}` : `v${BUILD_VERSION}`}
    </button>
  );
}
